export type VoivodeshipId =
  | 'dolnoslaskie'
  | 'kujawsko-pomorskie'
  | 'lodzkie'
  | 'lubelskie'
  | 'lubuskie'
  | 'malopolskie'
  | 'mazowieckie'
  | 'opolskie'
  | 'podkarpackie'
  | 'podlaskie'
  | 'pomorskie'
  | 'slaskie'
  | 'swietokrzyskie'
  | 'warminsko-mazurskie'
  | 'wielkopolskie'
  | 'zachodniopomorskie';

export const VOIVODESHIP_NAMES: Record<VoivodeshipId, string> = {
  dolnoslaskie: 'Dolnośląskie',
  'kujawsko-pomorskie': 'Kujawsko-Pomorskie',
  lodzkie: 'Łódzkie',
  lubelskie: 'Lubelskie',
  lubuskie: 'Lubuskie',
  malopolskie: 'Małopolskie',
  mazowieckie: 'Mazowieckie',
  opolskie: 'Opolskie',
  podkarpackie: 'Podkarpackie',
  podlaskie: 'Podlaskie',
  pomorskie: 'Pomorskie',
  slaskie: 'Śląskie',
  swietokrzyskie: 'Świętokrzyskie',
  'warminsko-mazurskie': 'Warmińsko-Mazurskie',
  wielkopolskie: 'Wielkopolskie',
  zachodniopomorskie: 'Zachodniopomorskie',
};

export const isVoivodeshipId = (value: string): value is VoivodeshipId =>
  Object.prototype.hasOwnProperty.call(VOIVODESHIP_NAMES, value);

export interface Dealer {
  id: string;
  title: string;
  voivodeship: VoivodeshipId;
  detail: string;
}

export type DealersByVoivodeship = Partial<Record<VoivodeshipId, Dealer[]>>;
